<template>
  <q-dialog v-model="deleteDialog" transition-show="fade" transition-hide="fade">
    <div class="initialBackDrop" style="min-height: 100vh">
      <div class="q-pa-md q-gutter-sm" style="width: 80ex; margin-left: auto; margin-right: auto; margin-top: 5%; margin-bottom: auto; border-radius: 10px;">
        <q-card style="padding: 50px; border-radius: 10px;" class="q-pa-md">
          <div align="right"><q-btn icon="close" flat round dense v-close-popup class="circle-btn text-primary" style="margin: -70px -40px 0px 0px;" /></div>
          <div class="dialogText">{{deleteDialogMessage}}</div>

          <br />

          <q-card-actions align="center" class="text-primary">
            <q-btn
              label="Cancel"
              color="cancelButton"
              class="q-ml-sm dialogButton"
              no-caps
              v-close-popup
            />
            <q-btn
              label="Delete"
              @click="deleteRecord"
              color="primary"
              class="dialogButton"
              no-caps
              v-close-popup
            />
          </q-card-actions>
        </q-card>
      </div>
    </div>
  </q-dialog>
</template>

<script>
import { computed, ref } from "vue";
import axios from "axios";
import NotificationHelper from "../helper/NotificationHelper";
import EmailService from "../service/EmailService.js";

export default {
  name: "AdminDelete",
  props: {
    currentUserUID: String,
    ipAddress: String,
    usersTable: Object,
    userGroupsTable: Object
  },
  setup(props) {
    const deleteDialog =  ref(false);
    const name = ref("");
    const email = ref(""); // users
    const userGroupUid = ref(""); // user groups

    const deleteDialogMessage = computed(() => {
      return email.value !== undefined ? `Delete "${name.value}" (${email.value})?` : `Delete "${name.value}"?`;
    });

    function deleteRow(prop) {
      name.value = prop.row.name;
      email.value = prop.row.email;
      userGroupUid.value = prop.row.userGroupUid;
      deleteDialog.value = true;
    }

    async function deleteRecord() {
      try {
        if (email.value !== undefined) {
          // delete user
          NotificationHelper.createNotification("Deleting User...");
          await axios.get(`${process.env.VUE_APP_API_GATEWAY}deleteUser?deleteEmail=${email.value}&currentUserUID=${props.currentUserUID}&ipAddress=${props.ipAddress}&key=${process.env.VUE_APP_API_KEY}`);
          await axios.get(`${process.env.VUE_APP_API_GATEWAY}saveUserGroupEmails?email=${email.value}&currentUserUID=${props.currentUserUID}&ipAddress=${props.ipAddress}&key=${process.env.VUE_APP_API_KEY}`);
          props.userGroupsTable.getUserGroups();
          props.usersTable.getUsers();
          NotificationHelper.createSuccessNotification("User Deleted Successfully");
        } else if (userGroupUid.value !== undefined) {
          // delete user group
          NotificationHelper.createNotification("Deleting User Group...");
          await axios.get(`${process.env.VUE_APP_API_GATEWAY}deleteUserGroup?uid=${userGroupUid.value}&currentUserUID=${props.currentUserUID}&ipAddress=${props.ipAddress}&key=${process.env.VUE_APP_API_KEY}`);
          props.userGroupsTable.getUserGroups();
          NotificationHelper.createSuccessNotification("User Group Deleted Successfully");
        }
      } catch (error) {
        EmailService.sendErrorEmail("AdminDelete.vue - deleteRecord", error);
        NotificationHelper.createErrorNotification("Error encountered. Please try again.");
      }
    }

    return {
      //variable properties
      deleteDialog,
      deleteDialogMessage,

      //functions
      deleteRow,
      deleteRecord
    };
  },
};
</script>